import { appDetails } from '@/utils/configs'

export const faqHero = {
  subtitle:
    'پاسخ سوالات رایج درباره سرمایه‌گذاری، تأمین مالی جمعی و فعالیت زیما را اینجا پیدا کنید.',
}

export const faqConsultantPhone = appDetails.supportPhone
export const faqConsultantPhoneLabel = appDetails.supportPhoneLabelRTL

export const faqHelpLinks = [
  {
    label: 'مشاهده طرح‌ها',
    href: '/crowdfunding-plan',
  },
]
